import React, {useCallback, useEffect, useState} from 'react';
import i18next from 'i18next';
import {toast} from 'react-toastify';
import GeneralModal from '../GeneralModal/GeneralModal';
import {NOTIFY_OPTS} from '../../constants/Notifiers';
import {Translation} from 'react-i18next';
import {formatUserName} from '../../Helpers/AdminHelpers';
import LabeledTextInput from '../../Custom UI/LabeledInputs/LabeledTextInput/LabeledTextInput';

const notifyAccountLockUpdatedSuccess = (aUserName) => toast(<Translation>{(t) => t('PATIENT_ACCOUNT_LOCK_SUCCESS', {aUserName})}</Translation>, NOTIFY_OPTS.autoCloseFiveSeconds);
const notifyAccountLockUpdatedFailure = (aUserName, aError) => toast(<Translation>{(t) => t('PATIENT_ACCOUNT_LOCK_FAILURE', {aUserName, aError})}</Translation>, NOTIFY_OPTS.autoCloseFiveSeconds);

const LockUserModal = ({isOpen, close, save, patient, lockUser}) => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const userName = formatUserName(patient);
  const normalizedReason = reason.trim();
  const canLock = normalizedReason.length >= 3 && !loading && patient && patient.id;
  
  useEffect(() => {
    setReason('');
    setLoading(false);
  }, [isOpen]);

  const closeModal = useCallback(() => {
    if(!loading){
      setReason('');
      close();
    }
  }, [loading, close]);

  const saveLock = useCallback(() => {
    if(canLock && lockUser){
      setLoading(true);
      lockUser(patient.id, reason).then(() => {
        notifyAccountLockUpdatedSuccess(userName);
        save();
        setLoading(false);
      }, (aError) => {
        notifyAccountLockUpdatedFailure(userName, aError?.data?.error || i18next.t('UNKNOWN_ERROR'));
        setLoading(false);
      });
    }
  }, [canLock, reason, lockUser, patient, save, userName]);

  return (
    <GeneralModal title={i18next.t('LOCK_USER', {aUserName:userName})}
                  isOpen={isOpen}
                  loading={loading}
                  handleSave={saveLock}
                  showFooter={true}
                  showHeader={true}
                  description={i18next.t('LOCK_USER_DESCRIPTION')}
                  noTitleHeading={true}
                  showSaveButton={canLock}
                  saveButtonTitle={i18next.t('LOCK')}
                  handleCloseModal={closeModal}
                  showCancelButton={true}>
      <LabeledTextInput className="modal-input"
                        label={i18next.t('MODIFICATION_REASON')}
                        value={reason}
                        handleSave={(aEvent) => setReason(aEvent.target.value)}
                        placeholder={i18next.t('MODIFICATION_REASON')}
      />
    </GeneralModal>
  );
};

export default LockUserModal;
